import { render, staticRenderFns } from "./dagreProject.vue?vue&type=template&id=ca838604&scoped=true"
import script from "./dagreProject.vue?vue&type=script&lang=js"
export * from "./dagreProject.vue?vue&type=script&lang=js"
import style0 from "./dagreProject.vue?vue&type=style&index=0&id=ca838604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca838604",
  null
  
)

export default component.exports